/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../../common/runtime';
import type { CallCenter, Company, Ivr, User } from '../models/index';
import {
  CallCenterFromJSON,
  CallCenterToJSON,
  CompanyFromJSON,
  CompanyToJSON,
  IvrFromJSON,
  IvrToJSON,
  UserFromJSON,
  UserToJSON,
} from '../models/index';

export interface GetCompanyRequest {
  companyId: number;
  projection?: string;
  shortKey?: boolean;
}

export interface GetContactRequest {
  contactKey: string;
  projection: string;
  shortKey?: boolean;
}

export interface GetContactsRequest {
  type: GetContactsTypeEnum;
  filter: GetContactsFilterEnum;
  projection: string;
  limit?: number;
  shortKey?: boolean;
  search?: string;
}

export interface GetCustomIvrRequest {
  ivrId: string;
}

export interface GetModelsByKeysRequest {
  projection: string;
  keys?: string;
  extended?: boolean;
  excludeSoftDeleted?: boolean;
}

export interface GetMyOfficesRequest {
  mine: boolean;
  keysOnly: boolean;
  includeRbac: boolean;
  shortKey: boolean;
}

export interface GetUserByIdRequest {
  userId: string;
  shortKey: boolean;
  projection?: string;
}

/**
 *
 */
export class DialpadContactApi extends runtime.BaseAPI {
  /**
   * Fetch a company based on company key.
   * Fetch Company
   */
  async getCompanyRaw(
    requestParameters: GetCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Company>> {
    if (requestParameters['companyId'] == null) {
      throw new runtime.RequiredError(
        'companyId',
        'Required parameter "companyId" was null or undefined when calling getCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['projection'] != null) {
      queryParameters['projection'] = requestParameters['projection'];
    }

    if (requestParameters['shortKey'] != null) {
      queryParameters['short_key'] = requestParameters['shortKey'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/company/{company_id}`.replace(
          `{${'company_id'}}`,
          encodeURIComponent(String(requestParameters['companyId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyFromJSON(jsonValue),
    );
  }

  /**
   * Fetch a company based on company key.
   * Fetch Company
   */
  async getCompany(
    requestParameters: GetCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Company> {
    const response = await this.getCompanyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Fetch a contact based on contact key.
   * Fetch Contact
   */
  async getContactRaw(
    requestParameters: GetContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CallCenter>> {
    if (requestParameters['contactKey'] == null) {
      throw new runtime.RequiredError(
        'contactKey',
        'Required parameter "contactKey" was null or undefined when calling getContact().',
      );
    }

    if (requestParameters['projection'] == null) {
      throw new runtime.RequiredError(
        'projection',
        'Required parameter "projection" was null or undefined when calling getContact().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['projection'] != null) {
      queryParameters['projection'] = requestParameters['projection'];
    }

    if (requestParameters['shortKey'] != null) {
      queryParameters['short_key'] = requestParameters['shortKey'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/contact/{contact_key}`.replace(
          `{${'contact_key'}}`,
          encodeURIComponent(String(requestParameters['contactKey'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CallCenterFromJSON(jsonValue),
    );
  }

  /**
   * Fetch a contact based on contact key.
   * Fetch Contact
   */
  async getContact(
    requestParameters: GetContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CallCenter> {
    const response = await this.getContactRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Fetch a list of contacts based on specific filters.
   * Fetch Contacts
   */
  async getContactsRaw(
    requestParameters: GetContactsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CallCenter>>> {
    if (requestParameters['type'] == null) {
      throw new runtime.RequiredError(
        'type',
        'Required parameter "type" was null or undefined when calling getContacts().',
      );
    }

    if (requestParameters['filter'] == null) {
      throw new runtime.RequiredError(
        'filter',
        'Required parameter "filter" was null or undefined when calling getContacts().',
      );
    }

    if (requestParameters['projection'] == null) {
      throw new runtime.RequiredError(
        'projection',
        'Required parameter "projection" was null or undefined when calling getContacts().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    if (requestParameters['projection'] != null) {
      queryParameters['projection'] = requestParameters['projection'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['shortKey'] != null) {
      queryParameters['short_key'] = requestParameters['shortKey'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/contact`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CallCenterFromJSON),
    );
  }

  /**
   * Fetch a list of contacts based on specific filters.
   * Fetch Contacts
   */
  async getContacts(
    requestParameters: GetContactsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CallCenter>> {
    const response = await this.getContactsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Fetch a custom IVR model based on custom IVR id.
   * Fetch custom IVR
   */
  async getCustomIvrRaw(
    requestParameters: GetCustomIvrRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Ivr>> {
    if (requestParameters['ivrId'] == null) {
      throw new runtime.RequiredError(
        'ivrId',
        'Required parameter "ivrId" was null or undefined when calling getCustomIvr().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/customivr/{ivr_id}`.replace(
          `{${'ivr_id'}}`,
          encodeURIComponent(String(requestParameters['ivrId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IvrFromJSON(jsonValue),
    );
  }

  /**
   * Fetch a custom IVR model based on custom IVR id.
   * Fetch custom IVR
   */
  async getCustomIvr(
    requestParameters: GetCustomIvrRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Ivr> {
    const response = await this.getCustomIvrRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Bulk fetch entity short keys by comma-delimited url params
   * Bulk fetch entities by short keys
   */
  async getModelsByKeysRaw(
    requestParameters: GetModelsByKeysRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<object>>> {
    if (requestParameters['projection'] == null) {
      throw new runtime.RequiredError(
        'projection',
        'Required parameter "projection" was null or undefined when calling getModelsByKeys().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['keys'] != null) {
      queryParameters['keys'] = requestParameters['keys'];
    }

    if (requestParameters['projection'] != null) {
      queryParameters['projection'] = requestParameters['projection'];
    }

    if (requestParameters['extended'] != null) {
      queryParameters['extended'] = requestParameters['extended'];
    }

    if (requestParameters['excludeSoftDeleted'] != null) {
      queryParameters['exclude_soft_deleted'] =
        requestParameters['excludeSoftDeleted'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/bulk`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Bulk fetch entity short keys by comma-delimited url params
   * Bulk fetch entities by short keys
   */
  async getModelsByKeys(
    requestParameters: GetModelsByKeysRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<object>> {
    const response = await this.getModelsByKeysRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Fetch office details
   */
  async getMyOfficesRaw(
    requestParameters: GetMyOfficesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<string>>> {
    if (requestParameters['mine'] == null) {
      throw new runtime.RequiredError(
        'mine',
        'Required parameter "mine" was null or undefined when calling getMyOffices().',
      );
    }

    if (requestParameters['keysOnly'] == null) {
      throw new runtime.RequiredError(
        'keysOnly',
        'Required parameter "keysOnly" was null or undefined when calling getMyOffices().',
      );
    }

    if (requestParameters['includeRbac'] == null) {
      throw new runtime.RequiredError(
        'includeRbac',
        'Required parameter "includeRbac" was null or undefined when calling getMyOffices().',
      );
    }

    if (requestParameters['shortKey'] == null) {
      throw new runtime.RequiredError(
        'shortKey',
        'Required parameter "shortKey" was null or undefined when calling getMyOffices().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['mine'] != null) {
      queryParameters['mine'] = requestParameters['mine'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['includeRbac'] != null) {
      queryParameters['include_rbac'] = requestParameters['includeRbac'];
    }

    if (requestParameters['shortKey'] != null) {
      queryParameters['short_key'] = requestParameters['shortKey'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/office`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Fetch office details
   */
  async getMyOffices(
    requestParameters: GetMyOfficesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<string>> {
    const response = await this.getMyOfficesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Fetch user by id
   */
  async getUserByIdRaw(
    requestParameters: GetUserByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<User>> {
    if (requestParameters['userId'] == null) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter "userId" was null or undefined when calling getUserById().',
      );
    }

    if (requestParameters['shortKey'] == null) {
      throw new runtime.RequiredError(
        'shortKey',
        'Required parameter "shortKey" was null or undefined when calling getUserById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['shortKey'] != null) {
      queryParameters['short_key'] = requestParameters['shortKey'];
    }

    if (requestParameters['projection'] != null) {
      queryParameters['projection'] = requestParameters['projection'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/user/{user_id}`.replace(
          `{${'user_id'}}`,
          encodeURIComponent(String(requestParameters['userId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UserFromJSON(jsonValue),
    );
  }

  /**
   * Fetch user by id
   */
  async getUserById(
    requestParameters: GetUserByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<User> {
    const response = await this.getUserByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const GetContactsTypeEnum = {
  Office: 'office',
  Department: 'department',
  CallCenter: 'call_center',
  CallRouter: 'call_router',
} as const;
export type GetContactsTypeEnum =
  (typeof GetContactsTypeEnum)[keyof typeof GetContactsTypeEnum];
/**
 * @export
 */
export const GetContactsFilterEnum = {
  Group: 'group',
} as const;
export type GetContactsFilterEnum =
  (typeof GetContactsFilterEnum)[keyof typeof GetContactsFilterEnum];
